import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "card-body p-3"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "text-danger fw-bold" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row mb-2" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "row mb-2" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "text-danger fw-bold" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/planosItensService";
import { f2dec } from "@/utils/funcoes";
import { useAcl } from "vue-simple-acl";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";

interface IProps {
  PlanoId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanosItens',
  props: {
    PlanoId: {}
  },
  setup(__props: any) {


//vue
const acl = useAcl();

//componentes
var props = __props;

function modeloVazio(): service.PlanoItem {
  return {
    planoItemId: 0,
    planoId: props.PlanoId ?? 0,
    descricao: "",
    idadeMinima: null,
    idadeMaxima: null,
    valor: 0,
    comSeguro: false,
    valorComSeguro: 0,
    ativo: true,
  } as service.PlanoItem;
}

var controle = reactive({
  planoId: props.PlanoId as number | null | undefined,
  itens: [] as service.PlanoItem[],
  model: modeloVazio(),
  janela: false,
  janPergunta: false,
  erro: "",
  status: ""
})

onMounted(() => {
  buscarItens();
});

watch(() => props.PlanoId, (newValue) => {
  controle.planoId = newValue;
  buscarItens();
});

async function buscarItens() {

  if (!props.PlanoId) {
    controle.itens = [];
    return;
  }

  controle.status = "Buscando items...";
  controle.erro = "";
  service.obter({ planoId: props.PlanoId } as service.Filtros)
    .then((itens) => {
      controle.itens = itens;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function salvar() {

  controle.status = "Salvando item...";
  controle.erro = "";

  controle.model.planoId = props.PlanoId ?? 0;

  service.salvar(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = modeloVazio();
      buscarItens();
      controle.janela = false;
    })
    .catch((error) => {
      controle.erro = `Erro ao salvar item: ${error}`;
      controle.status = "";
    });
}

function excluir(item: service.PlanoItem) {
  controle.model = item;
  controle.janPergunta = true;
}

function excluirConfirma() {
  controle.janPergunta = false;
  controle.status = "Excluindo item...";
  controle.erro = "";

  service.excluir(controle.model.planoItemId)
    .then(() => {
      controle.status = "";
      controle.model = modeloVazio();
      buscarItens();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Itens Adicionais")
          ], -1)),
          (!_unref(props).PlanoId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "row mb-2" }, [
                  _createElementVNode("div", { class: "col-md-12" }, [
                    _createElementVNode("p", { class: "" }, "Necessário cadastro do plano")
                  ])
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(controle).model = modeloVazio(); _unref(controle).janela = true})
                    }, "Adicionar")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Descrição"),
                          _createElementVNode("th", { class: "text-center" }, "Idade Mínima"),
                          _createElementVNode("th", { class: "text-center" }, "Idade Máxima"),
                          _createElementVNode("th", { class: "text-end" }, "Valor R$"),
                          _createElementVNode("th", { class: "text-center" }, "Com Seguro?"),
                          _createElementVNode("th", { class: "text-end" }, "Valor Com Seguro R$"),
                          _createElementVNode("th", null, "Ações")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(item.descricao), 1),
                            _createElementVNode("td", _hoisted_9, _toDisplayString(item.idadeMinima ?? '-'), 1),
                            _createElementVNode("td", _hoisted_10, _toDisplayString(item.idadeMaxima ?? '-'), 1),
                            _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(f2dec)(item.valor)), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(item.comSeguro ? 'Sim' : 'Não'), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(item.comSeguro ? _unref(f2dec)(item.valorComSeguro) : '-'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-primary me-1",
                                title: "Alterar registro",
                                onClick: ($event: any) => {_unref(controle).model = item; _unref(controle).janela = true}
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                              ]))], 8, _hoisted_14),
                              (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-danger",
                                    title: "Excluir registro",
                                    onClick: ($event: any) => (excluir(item))
                                  }, [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                  ]))], 8, _hoisted_15))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(controle).status), 1),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(controle).erro), 1)
                ])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createVNode(MsgBox, {
          id: 'janAddPlanoItem',
          class: "modal-md",
          "data-bs-backdrop": "static",
          exibir: _unref(controle).janela,
          titulo: 'Cadastro de Item',
          onOnFechou: _cache[7] || (_cache[7] = ($event: any) => (_unref(controle).janela = false)),
          "botao-gravar": true,
          "botao-fechar": true,
          onOnGravar: _cache[8] || (_cache[8] = ($event: any) => (salvar()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-3" }, " Descrição ", -1)),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.descricao,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.descricao) = $event)),
                  formato: 'Texto'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3" }, " Idade Mínima ", -1)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.idadeMinima,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.idadeMinima) = $event)),
                  formato: 'Numero'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, " Idade Máxima ", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.idadeMaxima,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.idadeMaxima) = $event)),
                  formato: 'Numero'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-3" }, " Valor R$ ", -1)),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(TextBox, {
                  modelValue: _unref(controle).model.valor,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.valor) = $event)),
                  formato: 'DoisDecimais',
                  class: "text-end"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-3" }, " Com Seguro? ", -1)),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(DropdownSimNao, {
                  modelValue: _unref(controle).model.comSeguro,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.comSeguro) = $event)),
                  class: "form-select form-select-sm"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model.comSeguro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, " Valor Com Seguro R$ ", -1)),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.valorComSeguro,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.valorComSeguro) = $event)),
                      formato: 'DoisDecimais',
                      class: "text-end"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(controle).status), 1),
                _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(controle).erro), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["exibir"])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPergunta',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[9] || (_cache[9] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[10] || (_cache[10] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})